var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/video-customer-service.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-5ad872ce!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/video-customer-service.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/VideoCustomerService.vue
// module id = 1358
// module chunks = 1